angular.module('TetherApp').directive('tetherButton', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherButton.html'
    }
});
